module.exports = __webpack_public_path__ + "static/media/img-4.f2584bd6.jpg";